import { getRaceFormDataFromApi } from '@core/Areas/Racing/Hooks/useRaceFormData/api'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { queryClient } from '@core/Data/ReactQuery/queryClient'

export const FormReactQueryService = {
  updateQueryCache(meetingId: string, meetingDate: Date, raceNumber: number): void {
    queryClient.fetchQuery({
      queryKey: queryKeys.racePageForm(meetingId, meetingDate, raceNumber),
      queryFn: () => getRaceFormDataFromApi(meetingId, meetingDate, raceNumber),
      staleTime: Infinity,
    })
  },
}
